import { useNavigate } from "react-router-dom";
import { ClientSearchResult } from "@/dentlab/src/store/Search/types";
import { Chip } from "@mui/material";
import { ResultCard } from "./SearchResultCard";
import { formatClientNameForSidebar } from "@/lib/utils/client-utils";

export const ClientResultCard: React.FC<{ client: ClientSearchResult }> = ({
	client,
}) => {
	const navigate = useNavigate();

	const displayName = formatClientNameForSidebar(
		client.first_name,
		client.last_name,
		client.company_name,
		client.is_company
	);

	return (
		<ResultCard
			onClick={() => {
				navigate(`/client/${client.id}`);
			}}
		>
			<Chip label={client.code} size="small" color="secondary" />
			<div className="text-lg">
				{displayName}
			</div>
		</ResultCard>
	);
};
